<template>
    <div class="float-left mr-1">
        <span class="text-warning">
            <i
                class="fa fa-file-text fa-lg icon-button"
                title="Justificativa"
                @click.stop="mostrarJustificativa()"
            ></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        rateio: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        mostrarJustificativa() {
            this.$swal({
                title: 'Justificativa',
                html: `${this.rateio.justificativa}`,
                icon: 'warning'
            })
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
